import { Translate } from '@chipinside/translate'

import TypeString from '#/components/FormatCell/Types/string'

export function TypeWithdrawalPeriodIndicador({
  label = Translate({ messageKey: 'without_withdrawal_period' }),
  level,
  value,
  ...rest
}) {
  const hasWithdrawallPeriod = Boolean(value)

  if (hasWithdrawallPeriod) {
    label = Translate({ messageKey: 'with_withdrawal_period' })
    level = 'warning'
  }

  return (
    //@ts-ignore
    <TypeString value={label} level={level} bold={hasWithdrawallPeriod} {...rest} />
  )
}
